import { useLocation } from 'react-router';

export const useURLParams = () => {
  const location = useLocation();
  const url: string = location.search;
  const urlParams = new URLSearchParams(url);
  return { urlParams };
};
